import {
  ALL_CONTENT_TYPES,
  STATIC_CONTENT_TYPES,
} from "fleet/constant/media-library";
import { PRIORITY_MAIN } from "fleet/constant/strategy-v2";
import { ConnectedSpotTable } from "fleet/controller/strategy-v2/connected-spot-table";
import { PropTypeMediaEntry } from "fleet/prop-types";
import { AddSpot } from "fleet/view/strategy-v2/add-spot";
import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FlatButton } from "ui/flat-button";
import { Header } from "ui/header";
import { ModalV2 } from "ui/modal-v2";

import { PropTypePriorities } from "./utils";

class SpotList extends React.PureComponent {
  static get propTypes() {
    return {
      buttonClass: PropTypes.string,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      spots: PropTypes.arrayOf(PropTypeMediaEntry),
      strategy: PropTypes.object,
      priority: PropTypePriorities.isRequired,
    };
  }

  static get defaultProps() {
    return {
      buttonClass: "default",
      className: "",
      disabled: false,
      strategy: {},
    };
  }

  constructor() {
    super();

    this.state = {
      showModal: false,
    };

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  getModalTitle(priority) {
    return this.isMainLoop(priority)
      ? "Add existing media, applications, or web pages to your strategy"
      : "Add existing media to your strategy";
  }

  getTitle(priority) {
    return this.isMainLoop(priority) ? "Main Loop" : "Fallback Loop";
  }

  getButtonHelpText(priority) {
    return (
      this.getModalTitle(priority) +
      ". To upload new media, go to media library."
    );
  }

  getValidContentTypes(priority) {
    return this.isMainLoop(priority) ? ALL_CONTENT_TYPES : STATIC_CONTENT_TYPES;
  }

  hideModal() {
    this.setState({ showModal: false });
  }

  isMainLoop(priority) {
    return priority === PRIORITY_MAIN.id;
  }

  showModal() {
    this.setState({ showModal: true });
  }

  render() {
    const {
      buttonClass,
      className,
      disabled,
      spots,
      strategy,
      priority,
      ...rest
    } = this.props;
    const { showModal } = this.state;

    const title = this.getTitle(priority);
    const modalTitle = this.getModalTitle(priority);
    const buttonHelpText = this.getButtonHelpText(priority);
    const validContentTypes = this.getValidContentTypes(priority);

    return (
      <div className={`strategy-components-list ${className}`} {...rest}>
        <Row>
          <Col xs={12}>
            <Header title={title} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FlatButton
              title="Add to Strategy"
              className={buttonClass}
              disabled={disabled}
              helpText={buttonHelpText}
              iconClass="fa-plus-square"
              onClick={this.showModal}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <ConnectedSpotTable
              priority={priority}
              spots={spots}
              strategy={strategy}
            />
          </Col>
        </Row>
        <ModalV2 show={showModal} onHide={this.hideModal} title={modalTitle}>
          <AddSpot priority={priority} validContentTypes={validContentTypes} />
        </ModalV2>
      </div>
    );
  }
}

export { SpotList };
